import { useState } from 'react';
import { useLocaleContext } from '@storefront/lib-global/context/localeContext';
import { useUserContext } from '@storefront/lib-global/context/userContext';
import { useNotifyBackInStockMutation } from '@storefront/lib-global/graphqlDocument/notifyMe/notifyMe.generated';
import { getCtLocale } from '@storefront/lib-global/utils';
import { sendNotifyMeEvent } from '@storefront/lib-global/utils/gtm/events/notify_me/sendNotifyMeEvent';
import { logger } from '@storefront/lib-global/utils/logger';
import { useSizeAndWidthContext } from '../context';

export function useNotifyBackInStock(initialError?: boolean) {
  const { locale } = useLocaleContext();
  const { selectedSize, selectedWidth, selectedSku } = useSizeAndWidthContext();
  const { customerData, isUserLoggedIn } = useUserContext();
  const [notifyBackInStockMutation, { data, loading }] = useNotifyBackInStockMutation();
  const [apiError, setApiError] = useState(initialError || false);

  const notifyBackInStock = async (email: string, productName: string) => {
    try {
      setApiError(false);
      await notifyBackInStockMutation({
        variables: {
          input: {
            email,
            locale: getCtLocale(locale),
            sku: selectedSku,
          },
        },
        onCompleted: () => {
          const customerNumber = isUserLoggedIn ? customerData?.customerNumber : 'not_logged';

          sendNotifyMeEvent({
            customer_number: customerNumber,
            item_name: productName,
            item_id: selectedSku,
            size: selectedSize,
            width: selectedWidth,
          });
        },
      });
    } catch (error) {
      console.error(error);
      setApiError(true);
      logger.warn(
        {
          error,
          productName,
          selectedSku,
          selectedSize,
          selectedWidth,
        },
        'notifyBackInStock',
      );
    }
  };

  return {
    notifyBackInStock,
    data,
    loading,
    apiError,
    setApiError,
  };
}
